/**
 * IntelV2Layout — tab shell for the V2 Fusion Intel product surface.
 *
 * Renders a top tab bar that links the 6 V2 product pages (Feed / Implications
 * / Decisions / Breaking Alerts / Assessments / Fusion). Each child route
 * renders inside <Outlet/> below the tabs.
 *
 * Sidebar collapses to a single "V2 Fusion Intel" entry → /intel/v2;
 * navigation between products happens via these tabs, not the sidebar.
 */

import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "/intel/v2", label: "Feed", end: true },
  { to: "/intel/v2/implications", label: "Implications" },
  { to: "/intel/v2/decisions", label: "Decisions" },
  { to: "/intel/v2/alerts", label: "Breaking Alerts" },
  { to: "/intel/v2/assessments", label: "Assessments" },
  { to: "/intel/v2/fusion", label: "Fusion" },
];

export default function IntelV2Layout() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-1 px-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 overflow-x-auto flex-shrink-0">
        <span className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mr-3 whitespace-nowrap">
          V2 Fusion Intel
        </span>
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                isActive
                  ? "border-blue-600 text-blue-600 dark:text-blue-400"
                  : "border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
